import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Message } from 'semantic-ui-react';
import { reportError, reportWarning } from '../../utils/error-handling-service';

class DyzioMessage extends Component {
  constructor() {
    super();
    this.state = {

    };
  }

  componentDidMount() {
    const { reportMethod, reportMessage, reportMessageArgs } = this.props;
    reportMethod(reportMessage, reportMessageArgs);
  }

  render() {
    return (
      <Message {...this.props} />
    );
  }
}

DyzioMessage.defaultProps = {
  reportMessageArgs: {},
};

DyzioMessage.propTypes = {
  reportMethod: PropTypes.func.isRequired,
  reportMessage: PropTypes.func.isRequired,
  reportMessageArgs: PropTypes.any,
};

const DyzioWarningMessage = props => (
  <DyzioMessage
    color="orange"
    icon="warning"
    warning
    reportMethod={props.reportMethod}
    reportMessage="Test warning message"
    {...props}
  />
);

const DyzioErrorMessage = props => (
  <DyzioMessage
    error
    reportMethod={props.reportMethod}
    reportMessage="Test error message"
    {...props}
  />
);

DyzioWarningMessage.propTypes = {
  reportMethod: PropTypes.func,
};

DyzioErrorMessage.propTypes = {
  reportMethod: PropTypes.func,
};

DyzioErrorMessage.defaultProps = {
  reportMethod: reportError,
};

DyzioWarningMessage.defaultProps = {
  reportMethod: reportWarning,
};

module.exports = {
  DyzioWarningMessage,
  DyzioErrorMessage,
};



/** WEBPACK FOOTER **
 ** ./src/components/dyzio-messages/index.js
 **/